import { ContextStore } from '../../../react-core/Flux/Variables';
import { RoutesHelper } from '../../../react-core/Utils/RoutesHelper';
import { AjaxWrapper } from '../../../react-core/Async/AjaxWrapper';
import { Promise } from '../../../react-core/Async/Promise';
import { BackOfficeProviderBulkValuationReport } from '../../Models/Models/BackOfficeIntegration/BackOfficeProviderBulkValuationReport';
import { IJsonDate } from '../../System/IJsonDate';

declare var IS_RUNNING_IN_APP_POOL;

export class BackOfficeProviderBulkValuationReportClient {
  private _culture: string;

  public constructor() {
    var contextStoreState = ContextStore.getContext();
    this._culture = contextStoreState.culture;
  }

  public get(bulkFileTypeId: number, networkId: number, companyCode: string, fromDate: IJsonDate, toDate: IJsonDate): Promise<Array<BackOfficeProviderBulkValuationReport>, any> {
    const subResourceUrl = 'robo'
    let actionRoute = '/{culture}/Api/BackOfficeIntegration/BackOfficeProviderBulkValuationReport/Get';
    if (IS_RUNNING_IN_APP_POOL) actionRoute = '/' + subResourceUrl + actionRoute
    const url = RoutesHelper.replacePlaceholdersInUrl(actionRoute, this._culture).toLowerCase();
    const data = { bulkFileTypeId: bulkFileTypeId, networkId: networkId, companyCode: companyCode, fromDate: fromDate, toDate: toDate }

    return AjaxWrapper.get<Array<BackOfficeProviderBulkValuationReport>, any>(url, data);
  }
}

